/* States classes that can be added on the html root element */
export default {
  searching: 'page-searching',
  search: 'page-search',
  autocomplete: 'page-autocomplete'
};
